module.exports = __webpack_public_path__ + "static/img/img_member_serve.134daab1.png";